export default {
  allregions: { is: 'Öll svæði', en: 'All regions' },
  capitalRegion: { is: 'Höfuðborgarsvæðið', en: 'Capital region' },
  suðurnesPeninsula: { is: 'Suðurnes', en: 'Suðurnes peninsula' },
  westIceland: { is: 'Vesturland', en: 'West Iceland' },
  westFjords: { is: 'Vestfirðir', en: 'West Fjords' },
  northIceland: { is: 'Norðurland', en: 'North Iceland' },
  eastIceland: { is: 'Austurland', en: 'East Iceland' },
  southIcelan: { is: 'Suðurland', en: 'South Iceland' },
};
